<template>
  <div>
    <v-dialog
      v-model="isDialogShow"
      width="600"
      max-width="100vw"
      scrollable
    >
      <v-card>
        <v-card-title>個人資料蒐集處理利用暨著作授權利用同意書</v-card-title>
        <v-card-text>
          <div>本人為參與新北市政府文化局（下稱「新北市文化局」）舉辦之2021年多元文化節「母語歌採集計畫」聲音徵集活動（下稱「本活動」），同意新北市文化局及其他為新北市文化局規劃、執行本活動之第三人（下合稱「活動團隊」），得為規劃、執行本活動之目的，蒐集、處理及利用本人提供之個人資料：</div>
          <ol>
            <li>
              蒐集之個人資料類別如本活動資料上傳網頁（https://soundstory.culturefestivalinntpc.tw/#/management/create ）所示。
            </li>
            <li>個人資料利用之期間為民國（下同）110年4月1日至110年7月1日或本活動結案（以孰晚者），利用之地區為全球各地。本人之電話、電子信箱將作為本活動內部行政使用，包括但不限於聯繫本人、核對本人身份等；本人於本活動資料上傳網頁所提供之其他與聲音故事相關之個人資料，除活動團隊內部行政使用外，亦將公開予大眾知悉。</li>
            <li>本人若欲行使個人資料保護法第三條之權利，得聯絡以下電郵：service@rollinginlife.tw。</li>
            <li>如本人不提供個人資料予活動團隊，將無法參與本活動。</li>
          </ol>
          <br>
          <div>此外，本人亦同意以下條款內容，以利活動團隊利用本人提供之音檔、文字及其他相關資料：</div>
          <ol>
            <li>本人無償授權活動團隊於110年4月1日至110年7月1日，為規劃、執行本活動之目的，在全球各地利用本人提供之音檔、文字、資訊及其他著作或內容。</li>
            <li>
              <span>授權內容</span>
              <ol type="A">
                <li>
                  <span>本人授權活動團隊利用之標的如下：</span>
                  <ol type="a">
                    <li>本人提供予活動團隊之音檔、聲音及其他音樂著作、錄音著作、視聽著作等（下稱「聲音創作」）；</li>
                    <li>本人提供予活動團隊之文字等語言著作、文字著作，及本人所提供與聲音創作有關之一切說明內容；及</li>
                    <li>本人於本活動資料上傳網頁上傳、填寫之一切內容。</li>
                  </ol>
                </li>
                <li>活動團隊得以任何方式利用本人之著作，包括但不限於重製、改作、編輯、公開發表、公開上映、公開傳輸、公開播送、公開演出、公開口述、公開展示、散布等，且利用之場合或平台並無限制，包括但不限於線上網站及實體展覽。</li>
                <li>除本人之電話及電子信箱外，本人透過本活動資料上傳網頁提供予活動團隊之聲音創作、文字、資訊或其他內容，以及本人另以其他方式提供有關聲音創作之一切內容，本人皆同意活動團隊得將該等內容以任何方式公開揭露，包括但不限於揭露於線上網站及實體展覽。</li>
                <li>活動團隊得以本人提供之資訊，公開作為聲音創作之說明，包括但不限於公開揭露聲音創作時，表示本人之姓名。</li>
                <li>因本人提供之聲音創作、文字、資訊或其他內容將由活動團隊經改作編輯後上傳及儲存於網路，該等內容將持續於網路儲存、公開至本活動結案止。</li>
              </ol>
            </li>
            <li>本人擔保，本人提供活動團隊利用之著作已合法取得所有相關之權利，並無侵權之情事。若提供予活動團隊之聲音創作、文字、資訊或其他內容，涉及第三人之權利者，本人應合法取得其授權，供活動團隊於本同意書之範圍內使用。若活動團隊因利用本人提供之著作或其他內容而受第三人為任何主張或請求，本人應向活動團隊負損害賠償之責，賠償範圍包括合理之律師費、訴訟費。</li>
            <li>本人擔保，本人提供被授權人利用之聲音創作、文字或資訊均無違反公序良俗或其他違反法令規定之情事。</li>
            <li>若活動團隊因利用本人提供之聲音創作、文字或資訊而受有任何損害，本人應向活動團隊負損害賠償責任。</li>
            <li>本人同意不向活動團隊行使著作人格權。</li>
            <li>若本人提供之資訊有誤，致本人無法參與本活動、活動團隊無法聯繫本人、活動團隊公開之資訊有誤或其他類似情事，本人不得向活動團隊為任何主張或請求。</li>
            <li>活動團隊有審核本人提供之聲音創作、文字或資訊之權利，活動團隊得決定是否利用、公開本人提供之前述內容，並得將本人提供之前述內容從網路或任何載體上移除，本人不得向活動團隊為任何主張或請求。</li>
            <li>本同意書一部分無效，不影響其他部分之效力。</li>
            <li>本同意書之解釋適用，以中華民國法律為準據法。若因本同意書之履行或本活動之執行有任何爭議，本人同意以臺灣臺北地方法院為第一審管轄法院。</li>
          </ol>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDialog"
          >我了解哩</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'DataAuthorizationRulesDialog',
  data: () => ({
    isDialogShow: false
  }),
  methods: {
    openDialog () {
      this.isDialogShow = true
    },
    closeDialog () {
      this.isDialogShow = false
    }
  }
}
</script>
